import getRoles from './getRoles';
import addUserRole from './addUserRole';
import deleteUserRole from './deleteUserRole';
import getUserRoles from './getUserRoles';

export default {
  getRoles,
  addUserRole,
  deleteUserRole,
  getUserRoles,
};
